import { Component, Input, OnInit } from '@angular/core';
import { AlliancesService } from '@app/core/services/alliances.service';

@Component({
  selector: 'app-captured-form',
  templateUrl: './captured-form.component.html',
  styleUrls: ['./captured-form.component.css'],
})
export class CapturedFormComponent implements OnInit {
  @Input() infoLead: any;

  constructor(private srvAlliances: AlliancesService) {}

  ngOnInit(): void {
    this.infoLead = {
      name: '',
      contactEmail: '',
      contactName: '',
      contactPhone: '',
      city: '',
      section: '',
      arquetipo: '',
      firstContactDate: '',
    };
  }
}
